import React from 'react'
import LoginWrapper from '../LoginWrapper/LoginWrapper'

function LandingScreen() {
    return (
        <LoginWrapper />
    )
}

export default LandingScreen